export const SoftSkillsActionTypes = {
    FETCH_SOFT_SKILLS_STATUS: 'FETCH_SOFT_SKILLS_STATUS',
    FETCH_SOFT_SKILLS_STATUS_SUCCESS: 'FETCH_SOFT_SKILLS_STATUS_SUCCESS',
    FETCH_SOFT_SKILLS_STATUS_FAILURE: 'FETCH_SOFT_SKILLS_STATUS_FAILURE',
    CONTINUE_TO_INTRO: 'CONTINUE_TO_INTRO',
    CONTINUE_TO_LANDING: 'CONTINUE_TO_LANDING',
};
